import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import {
  createPartFileName,
  getPartGraphicByFilename,
} from 'components/SwitchAndGauge/utils'
import strings from 'utils/strings'

import {
  StyledAntdCard,
  StyledRadio,
  CardContent,
  PartImageContainer,
  CardTextSection,
  PartNumber,
  DetailRow,
  DetailLabel,
  DetailValue,
} from './SwitchDetailCard.style'

const toTitleCase = (str) =>
  str ? str.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : ''
const stripSignalType = (name) =>
  name ? name.replace(/\s*\([^)]*\)\s*$/, '') : ''

// PBI 147363 - Documentation 4: Updated to vertical layout with image on top
// PBI 147363 - Documentation 9: Added disabled prop for unavailable switch
const SwitchDetailCard = ({
  handleSwitchSelection,
  selectedPanelNumber,
  className,
  panelNumber,
  panelDescription,
  type,
  disabled,
}) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const radioRef = useRef(null)

  const onSelection = () => {
    if (disabled) return
    handleSwitchSelection(panelNumber)
  }

  const fileName = createPartFileName(panelNumber)
  const Part = getPartGraphicByFilename(fileName)

  const renderPart = () => {
    if (!Part) {
      const BlankPart = getPartGraphicByFilename('Part__Blank_Switch')
      return BlankPart ? <BlankPart style={{ width: 50, height: 100 }} /> : null
    }
    return <Part style={{ width: 50, height: 100 }} />
  }

  const radioSelected = panelNumber === selectedPanelNumber && !disabled
  const cardClassName = `${className || ''} ${
    radioSelected ? 'selected' : ''
  }`.trim()

  return (
    <StyledAntdCard
      className={cardClassName}
      onClick={onSelection}
      onMouseEnter={() => disabled && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <CardContent>
        <Tooltip
          title={strings.switch_already_on_vehicle}
          placement="right"
          visible={showTooltip}
          overlayStyle={{ maxWidth: 'none' }}
          overlayInnerStyle={{
            whiteSpace: 'nowrap',
            boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.15)',
          }}
        >
          <span ref={radioRef}>
            <StyledRadio
              checked={radioSelected}
              vertical={false}
              disabled={disabled}
            />
          </span>
        </Tooltip>
        <PartImageContainer>{renderPart()}</PartImageContainer>
        <CardTextSection>
          <PartNumber>{panelNumber}</PartNumber>
          <DetailRow>
            <DetailLabel>{strings.description}:</DetailLabel>
            <DetailValue>{stripSignalType(panelDescription)}</DetailValue>
          </DetailRow>
          <DetailRow>
            <DetailLabel>{strings.type_cap}:</DetailLabel>
            <DetailValue>{toTitleCase(type)}</DetailValue>
          </DetailRow>
        </CardTextSection>
      </CardContent>
    </StyledAntdCard>
  )
}

SwitchDetailCard.propTypes = {
  selectedPanelNumber: PropTypes.string,
  handleSwitchSelection: PropTypes.func,
  className: PropTypes.string,
  panelNumber: PropTypes.string,
  panelDescription: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
}

export default SwitchDetailCard
